import { render, staticRenderFns } from "./shopSplitAction.vue?vue&type=template&id=ceee4564&scoped=true"
import script from "./shopSplitAction.vue?vue&type=script&lang=js"
export * from "./shopSplitAction.vue?vue&type=script&lang=js"
import style0 from "./shopSplitAction.vue?vue&type=style&index=0&id=ceee4564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceee4564",
  null
  
)

export default component.exports